<template>
    <div
        class="l-header"
        data-qa="header"
        v-html="header.html"
    />
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useEventListener } from '@vueuse/core';
import { getQueryToSaveApplicationAfterAuth } from '../../utils/saveApplicationAfterAuth';
import { useHeaderStore } from '../../stores/header-store';

const router = useRouter();
const header = useHeaderStore();

const emit = defineEmits(['open-login-modal']);

useEventListener(window, 'mf-header:click-loginButton', () => {
    const loginRedirectLink = router.resolve({
        name: 'login',
        query: {
            state: getQueryToSaveApplicationAfterAuth().state,
            registerState: getQueryToSaveApplicationAfterAuth().registerState,
        },
    }).href;
    emit('open-login-modal', loginRedirectLink);
});
</script>

<style lang="scss">
@import '~@karriereat/global-styles/scss/settings/breakpoint';

$defaultHeaderHeight: 60px;
$zIndexNav: 610;

.l-header {
    z-index: $zIndexNav;
    height: $defaultHeaderHeight;

    &__hide {
        @media (min-width: $k-breakpoint--m) {
            display: none;
        }
    }
}
</style>
